// src/components/Footer.jsx
import './footer.css';

const Footer = () => (
  <footer className='basic-section'>
    {/* footer menu */}
    <div className='footer-legal'>
      <div className='rights-block'>
        <div className='logo-bw'>
          <img
            src='https://lucivia.com/assets/images/logo/LogoL-bw.svg'
            loading='lazy'
            alt='Lucivia LLC'
            className='logo-bw'
          />
        </div>

        {/* copyrights */}
        <div className='rights-root'>
          <div className='lucivia-text'>
            <img
              src='https://lucivia.com/assets/images/logo/Lucivia-bw.svg'
              loading='lazy'
              alt='Lucivia LLC'
              className='logo-bw'
            />
          </div>

          <div className='rights'>
            &#169; <span>{new Date().getFullYear()}</span> All rights reserved.
          </div>
        </div>
      </div>

      <div>
        <img
          src='https://lucivia.com/assets/images/logo/data-join.svg'
          width='170'
          loading='lazy'
          alt='Lucivia LLC'
          className='lucivia-logo in-header'
        />
      </div>

      <div className='legal-links-block nostack'>
        <a
          className='sub-footer'
          href='https://lucivia.com/legal/luci-service-agreement.shtml'>
          <span className='text body2'>Service agreement</span>
        </a>
        <a
          className='sub-footer'
          href='https://lucivia.com/privacy/luci-privacy-policy.shtml'>
          <span className='text body2'>Privacy policy</span>
        </a>
        <a
          className='sub-footer'
          href='https://lucivia.com/privacy/luci-cookie-policy.shtml'>
          <span className='text body2'>Cookie policy</span>
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
